/* eslint-env browser */
/* eslint-disable react/jsx-no-target-blank */

import React from 'react';
import PureComponent from 'react-pure-render/component';
import { connect } from 'react-redux';
import { replace } from 'redux-router';
import has from 'lodash/has';
import { loadActivate, activateUser, loadSetup, setupUser, loadConvert, convertUser, setHeader, setFlashMessage, removeFlashMessage, removeErrorMessage, validateLoginState, logout } from 'actions';

import Loading from 'components/common/Loading';

import Input from '@klarna/ui/uncontrolled/Input';
import Dropdown from '@klarna/ui/uncontrolled/Dropdown';

class ActivatePage extends PureComponent {
  static loadData(props) {
    const { action_type, id, code, type, action, state_string } = props;

    if( action_type == 'activation' || action_type == '' ) {
      props.loadActivate(id, code, 
        (response, dispatch) => {

        },
        (error, dispatch) => {
          if (has(error, 'error_msgs[0]')) {
            props.setFlashMessage(error.error_msgs.join('. '), 'error');
            // setTimeout(() => props.removeFlashMessage(), 5000);
            props.replace('/calendar');
          }
        }
      );
    } else if( action_type == 'setup' ) {
      props.loadSetup(type, state_string, 
        (response, dispatch) => {
          if(response.action && response.action == 'convert') {
            if(response.notice_msgs) {
              const noticeMessage = response.notice_msgs.join('. ');
              dispatch(setFlashMessage(noticeMessage, 'notice'));
              // setTimeout(() => dispatch(removeFlashMessage()), 5000);
            }

            if(response.type == 1 || response.type == 6) {
              // props.action_type = 'convert';
            } else {
              props.replace('/login');
            }
          }
        },
        (error, dispatch) => {
          if (has(error, 'error_msgs[0]')) {
            props.setFlashMessage(error.error_msgs.join('. '), 'error');
            // setTimeout(() => props.removeFlashMessage(), 5000);
            props.replace('/calendar');
          }
        }
      );
    }
  }

  static updateHeader(props) {
    // const { id, code } = props;
    // props.setHeader('Edit Event', false, '', <Link to={`/calendar/details/${event_id}`}>Cancel</Link>);
    props.setHeader(false);
  }

  constructor(props) {
    super(props);

    this.state = {
      id: null,
      email: '',
      password: '',
      retype_pass: '',
      first_name: '',
      last_name: '',
      address: '',
      city: '',
      state: '',
      zip: '',
      work_phone: '',
      cell_phone: '',
      home_phone: '',
      fax: '',
      action_type: '',
    };
  }

  componentWillMount() {
    ActivatePage.loadData(this.props);
    ActivatePage.updateHeader(this.props);

    this.handleActivate = this.handleActivate.bind(this);

    // Check for a saved session and validate it's still valid
    const authToken = window.persistStore.getItem('auth_token');
    const userId = window.persistStore.getItem('user_id');
    if (authToken && userId) {
      this.props.validateLoginState(authToken, userId, () => {
        this.props.replace('/calendar');
      }, () => {
        this.props.logout();
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    let loadData = false;

    if(nextProps.action_type == this.props.action_type) {
      if(nextProps.action_type == 'activation') {
        if ((nextProps.id && nextProps.id !== this.props.id) || (nextProps.code && nextProps.code !== this.props.code)) {
          loadData = true;
        }
      } else if(nextProps.action_type == 'setup') {
        if ((nextProps.type && nextProps.type !== this.props.type) || (nextProps.action && nextProps.action !== this.props.action) || (nextProps.state_string && nextProps.state_string !== this.props.state_string)) {
          loadData = true;
        }
      }
    } else {
      loadData = true;
    }

    if(loadData) {
      this.props.removeErrorMessage();
      ActivatePage.loadData(nextProps);
    }

    if(!nextProps.isLoading) {

      let setState = false;

      if(this.state.action_type != nextProps.action_type) {
        setState = true;
      } else if(nextProps.action_type == 'activation') {
        if(this.state.id != nextProps.data.id) {
          setState = true;
        }
      } else if(nextProps.action_type == 'setup') {
        // if(this.state.state_string != nextProps.data.state_string) {
        //   setState = true;
        // }
      }

      if(setState) {
        this.setState({
          email: nextProps.data.email,
          first_name: nextProps.data.first_name,
          last_name: nextProps.data.last_name,
          password: '',
          retype_pass: '',
          address: nextProps.data.address,
          city: nextProps.data.city,
          state: nextProps.data.state,
          zip: nextProps.data.zip,
          work_phone: nextProps.data.work_phone,
          cell_phone: nextProps.data.cell_phone,
          home_phone: nextProps.data.home_phone,
          fax: nextProps.data.fax,
          action_type: nextProps.action_type,
        });

        if(nextProps.action_type == 'activation') {
          this.setState({
            id: nextProps.data.id,
          });
        } else if(nextProps.action_type == 'setup') {
          // this.setState({
          //   state_string: nextProps.data.state_string,
          // });
        }
      }

      if (nextProps.data.auth_token > '') {
        this.props.removeErrorMessage();

        if(nextProps.action_type == 'activation') {
          nextProps.setFlashMessage('Account Activated Successfully');
        } else if(nextProps.action_type == 'setup') {
          nextProps.setFlashMessage('Account Setup Successfully');
        }

        setTimeout(() => nextProps.removeFlashMessage(), 5000);
        nextProps.replace('/calendar');
      }
    }
  }

  handleActivate(event) {
    event.preventDefault();

    var error_msgs = [];

    /*if(this.state.password != this.state.retype_pass) {
      error_msgs.push('Please type the same password in both fields.');
    } else if(this.state.password.length < 1) {
      error_msgs.push('Please provide a password.');
    }

    if(this.state.first_name.length < 1) {
      error_msgs.push('Please provide a first name.');
    }

    if(this.state.last_name.length < 1) {
      error_msgs.push('Please provide a last name.');
    }*/

    if(error_msgs.length > 0) {
      this.props.setFlashMessage(error_msgs.join('. '), 'error');
    } else {
      if(this.props.action_type == 'activation') {
        this.props.activateUser(
          this.props.id,
          this.props.code,
          {
              email: this.state.email,
              password: this.state.password,
              retype_pass: this.state.retype_pass,
              first_name: this.state.first_name,
              last_name: this.state.last_name,
              address: this.state.address,
              city: this.state.city,
              state: this.state.state,
              zip: this.state.zip,
              work_phone: this.state.work_phone,
              cell_phone: this.state.cell_phone,
              home_phone: this.state.home_phone,
              fax: this.state.fax,
          },
          (response, dispatch) => {
              
          },
          (error, dispatch) => {

          }
        );
      } else if(this.props.action_type == 'setup') {
        this.props.setupUser(
          this.props.type,
          this.props.state_string,
          {
              email: this.state.email,
              password: this.state.password,
              retype_pass: this.state.retype_pass,
              first_name: this.state.first_name,
              last_name: this.state.last_name,
              address: this.state.address,
              city: this.state.city,
              state: this.state.state,
              zip: this.state.zip,
              work_phone: this.state.work_phone,
              cell_phone: this.state.cell_phone,
              home_phone: this.state.home_phone,
              fax: this.state.fax,
          },
          (response, dispatch) => {
              if(response.action && response.action == 'convert') {
                if(response.notice_msgs) {
                  const noticeMessage = response.notice_msgs.join('. ');
                  dispatch(setFlashMessage(noticeMessage, 'notice'));
                  // setTimeout(() => dispatch(removeFlashMessage()), 5000);
                }

                if(response.type == 1 || response.type == 6) {
                  this.props.action_type = 'convert';
                } else {
                  this.props.replace('/login');
                }
              }
          },
          (error, dispatch) => {

          }
        );
      } else if(this.props.action_type == 'convert') {
        this.props.convertUser(
          this.props.type,
          this.props.state_string,
          {
              id: this.props.id,
              password: this.state.password,
          },
          (response, dispatch) => {

          },
          (error, dispatch) => {

          }
        );
      }
    }
    return;
  }

  render() {
    if (this.props.isLoading) {
      return (
        <Loading withWrapper />
      );
    }

    const { data } = this.props;
    const { email } = data;

    let emailField;

    if(email.length > 0) {
      emailField = (
        <div className="activate-field">
          <Input
            name="email"
            icon="email"
            label="Email"
            value={email}
            disabled
          />
        </div>
      );
    } else {
      emailField = (
        <div className="activate-field">
          <Input
            name="email"
            type="email"
            icon="email"
            label="Email"
            value={this.state.email}
            onChange={(e) => this.setState({email: e.target.value})}
          />
        </div>
      );
    }

    let firstNameField;
    let lastNameField;

    if(this.props.action_type != 'convert') {

      if(this.props.action_type == 'activation' || data.first_name.length < 1) {
        firstNameField = (
          <div className="activate-field">
            <Input
              name="first_name"
              icon="person"
              label="First Name"
              value={this.state.first_name}
              onChange={(e) => this.setState({first_name: e.target.value})}
            />
          </div>
        );
      } else {
        firstNameField = (
          <div className="activate-field">
            <Input
              name="first_name"
              icon="person"
              label="First Name"
              value={data.first_name}
              disabled
            />
          </div>
        );
      }

      if(this.props.action_type == 'activation' || data.last_name.length < 1) {
        lastNameField = (
          <div className="activate-field">
            <Input
              name="last_name"
              icon="person"
              label="Last Name"
              value={this.state.last_name}
              onChange={(e) => this.setState({last_name: e.target.value})}
            />
          </div>
        );
      } else {
        lastNameField = (
          <div className="activate-field">
            <Input
              name="last_name"
              icon="person"
              label="Last Name"
              value={data.last_name}
              disabled
            />
          </div>
        );
      }
    }

    let tandemLogo = window.EXPANDED_APP_ROOT + 'img/tandem-logo-gray@2x.png';

    if (has(window.CONFIG, 'ui')) {
      if (window.CONFIG.ui === 'card' || window.CONFIG.ui === 'shore2') {
        tandemLogo = window.EXPANDED_APP_ROOT + 'img/tandem-logo2-gray@2x.png';
      }
    }

    if(this.props.action_type == 'convert') {
      return (
        <section className="activate-page">
          <div className="card">
            
            <div className="header">
              <img src={tandemLogo} className="tandemLogo" alt="logo" />
            </div>

            <form onSubmit={this.handleActivate}>

               <div className="activate-fields">
                
                {emailField}

                <div className="activate-field">
                  <Input
                    type="password"
                    name="password"
                    icon="lock"
                    label="Password"
                    value={this.state.password}
                    focus={true}
                    onChange={(e) => this.setState({password: e.target.value})}
                  />
                </div>

              </div>

              <div className="activate-buttons">
                <button className="primary block" onClick={this.handleActivate}>Convert</button>
              </div>
            </form>

          </div>
        </section>
      );
    } else {

      let button_text = 'Activate';
      if(this.props.action_type == 'setup') {
        button_text = 'Setup';
      }
      return (
        <section className="activate-page">
          <div className="card">
            
            <div className="header">
              <img src={tandemLogo} className="tandemLogo" alt="logo" />
            </div>

            <form onSubmit={this.handleActivate}>

               <div className="activate-fields">
                
                {emailField}

                <div className="activate-field">
                  <Input
                    type="password"
                    name="password"
                    icon="lock"
                    label="Password"
                    value={this.state.password}
                    focus={true}
                    onChange={(e) => this.setState({password: e.target.value})}
                  />
                </div>

                <div className="activate-field">
                  <Input
                    type="password"
                    name="retype_pass"
                    icon="lock"
                    label="Re-type Password"
                    value={this.state.retype_pass}
                    onChange={(e) => this.setState({retype_pass: e.target.value})}
                  />
                </div>

                {firstNameField}
                {lastNameField}

                {data.config.user_require_address == '1' && (
                  <div className="activate-phone-fields">

                    <div className="activate-field">
                      <Input
                        name="address"
                        label="Address"
                        value={this.state.address}
                        onChange={(e) => this.setState({address: e.target.value})}
                      />
                    </div>

                    <div className="activate-field">
                      <Input
                        name="city"
                        label="City"
                        value={this.state.city}
                        onChange={(e) => this.setState({city: e.target.value})}
                      />
                    </div>

                    <div className="activate-field">
                      <Dropdown
                        name="state"
                        label={data.state_title}
                        value={this.state.state}
                        options={data.state_data}
                        onChange={(e) => this.setState({state: e.target.value})}
                      />
                    </div>

                    <div className="activate-field">
                      <Input
                        name="zip"
                        label="Zip"
                        value={this.state.zip}
                        onChange={(e) => this.setState({zip: e.target.value})}
                      />
                    </div>

                  </div>
                )}

                {data.config.user_require_phone == '1' && (
                  <div className="activate-phone-fields">

                    <div className="activate-field">
                      <Input
                        name="work_phone"
                        type="tel"
                        icon="phone"
                        label="Work Phone"
                        value={this.state.work_phone}
                        onChange={(e) => this.setState({work_phone: e.target.value})}
                      />
                    </div>

                    <div className="activate-field">
                      <Input
                        name="cell_phone"
                        type="tel"
                        icon="phone"
                        label="Cell Phone"
                        value={this.state.cell_phone}
                        onChange={(e) => this.setState({cell_phone: e.target.value})}
                      />
                    </div>

                    <div className="activate-field">
                      <Input
                        name="home_phone"
                        type="tel"
                        icon="phone"
                        label="Home Phone"
                        value={this.state.home_phone}
                        onChange={(e) => this.setState({home_phone: e.target.value})}
                      />
                    </div>

                    <div className="activate-field">
                      <Input
                        name="fax"
                        type="tel"
                        icon="phone"
                        label="Fax"
                        value={this.state.fax}
                        onChange={(e) => this.setState({fax: e.target.value})}
                      />
                    </div>

                  </div>
                )}

              </div>

              <div className="activate-buttons">
                <button className="primary block" onClick={this.handleActivate}>{button_text}</button>
              </div>
            </form>

          </div>
        </section>
      );
    }
  }
}

function mapStateToProps(state) {
  const { activation_code, type, action, state_string } = state.router.location.query;
  let { id } = state.router.location.query;
  const data = state.activate;

  let action_type;

  if( typeof id != 'undefined' && typeof activation_code != 'undefined' ) {
    action_type = 'activation';
  } else if( typeof type != 'undefined' && typeof action != 'undefined' && typeof state_string != 'undefined' ) {
    action_type = 'setup';
  }

  let isLoading = true;

  if(data) {
    if(data.isLoading === false) {
      isLoading = false;
    }

    if(data.id > '') {
      id = data.id;
    }

    if(data.action > '') {
      action_type = data.action;
    }
  }

  return {
    id,
    code: activation_code,
    type,
    action,
    state_string,
    action_type,
    isLoading,
    data,
  };
}

export default connect(mapStateToProps, {
  loadActivate,
  activateUser,
  loadSetup,
  setupUser,
  loadConvert,
  convertUser,
  setHeader,
  replace,
  setFlashMessage,
  removeFlashMessage,
  removeErrorMessage,
  validateLoginState,
  logout,
})(ActivatePage);



// WEBPACK FOOTER //
// ./src/app/containers/ActivatePage.js